import './styles.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';

import { I18n, Translate } from '@utils/i18n';
import { useAuth } from '_clean-code/api/hooks/useAuth';
import { useToast } from '@pulsarml/avalon-ui';
import MicrosoftLogo from '@components/MicrosoftLogo';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const MicrosoftLoginPage = () => {
  const { loginWithMicrosoft } = useAuth();
  const { toast } = useToast();
  const emailInputRef = React.useRef<HTMLInputElement>(null);

  const handleContinue = (event: React.FormEvent) => {
    event.preventDefault();
    const email = emailInputRef.current?.value.trim().toLowerCase() ?? '';
    if (!EMAIL_REGEX.test(email)) {
      toast({
        variant: 'error',
        title: I18n.t('microsoft_login_enter_work_email')
      });
      return;
    }
    loginWithMicrosoft.mutate(email);
  };

  return (
    <div className="py-7 px-5">
      <form id="login-form" className="login-form-1" onSubmit={handleContinue}>
        <div>
          <label htmlFor="lg_microsoft_email" className="input__label">
            <Translate value="email" />
            &nbsp;*
          </label>
          <div className="input-group py-1">
            <input
              type="email"
              className="form-control"
              id="lg_microsoft_email"
              name="microsoft-email"
              placeholder="name@company.com"
              required
              ref={emailInputRef}
            />
          </div>
        </div>

        <button
          type="submit"
          className="btn mt-4 submit-button submit-button--outline px-4 tw-flex tw-items-center tw-justify-center tw-gap-2"
          disabled={loginWithMicrosoft.isPending}
        >
          {loginWithMicrosoft.isPending ? (
            <ClipLoader size={20} loading color={'#fff'} />
          ) : (
            <>
              <MicrosoftLogo size={18} />
              {I18n.t('continue_with_microsoft')}
            </>
          )}
        </button>

        <div className="text-center form-message mt-4">
          <Link to="/login">
            <Translate value="microsoft_login_back_to_login" />
          </Link>
        </div>
      </form>
    </div>
  );
};

export default MicrosoftLoginPage;
